<template>
  <div
    id="category"
    v-if="isServiceCategory"
    class="bg-documentGray nav-category"
    :style="`left: ${idpBtnLocation}px`"
  >
    <div
      v-for="(service, index) of serviceLinkList"
      :key="index"
      class="t-body1 t-color-bodyGrayA font-r l-spacing48 category-align-item"
    >
      <a
        class="t-body1 font-r cursor-pointer l-spacing48 category"
        tabindex="0"
        :href="service.url"
        target="_blank"
      >
        {{ service.name}}
      </a>
    </div>
  </div>
</template>

<script>
import { storageConstants } from "@/utils/enum/StorageConstants";

export default {
  props: ["isServiceCategory", "categoryList", "idpBtnLocation"],

  data() {
    return {
      serviceLinkObj: JSON.parse(
        localStorage.getItem(storageConstants.idpServiceUrl)
      ),
      serviceLinkList: [],
    };
  },

  mounted() {
    this.serviceLinkList = Object.entries(this.serviceLinkObj)
      .filter(([key, url]) => {
        if (key !== "idpUrl" && key !== "githubUrl") return [key, url];
      })
      .map(([key, url]) => {
        let name;
        if (key === "udemyUrl") {
          name = this.$t("3901");
        } else if (key === "judgeUrl") {
          name = this.$t("3902");
        } else if (key === "reviewBoardUrl") {
          name = this.$t("3903");
        } else {
          return;
        }
        return { name, url };
      });
  },
};
</script>

<style scoped>
.nav-category {
  position: fixed;
  width: 306px;
  height: auto;
  top: 68px;
  z-index: 1001;
  padding: 8px 0;
  border-radius: 4px;
}

.category-align-item {
  margin-right: auto;
  height: 48px;

  display: flex;
  justify-content: normal;
  align-items: center;

  color: var(--BodygrayA);
  font-weight: 400;
  cursor: pointer;
}
.category {
  padding-left: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: var(--BodygrayA);
}

.category:hover {
  font-weight: 900;
  color: var(--HeadlineBlack);
  background-color: var(--BlackHover);
}
.l-200 {
  left: 200px;
}

.l-306 {
  left: 306px;
}
</style>
